import type { Activity } from 'features/script/script-model'
import { agendaClock, AgendaStep } from 'presenter-mode/model/agenda-clock'

const isGroupWork = (activity: Activity | undefined): boolean =>
	activity?.type === 'SIMPLE_GROUPING' || activity?.type === 'GROUPING'

/**
 * When the group work on screen is planned to end: the planned end of the
 * agenda step it is. Only while the current step is group work - started
 * from the menu, the group work is no step and the agenda's times are some
 * other item's - and only while that end is still ahead: a plan already
 * behind us is no plan, as in the lobby's "We are back at".
 */
export const groupWorkEnd = (
	current: AgendaStep | undefined,
	now: Date
): Date | undefined => {
	if (!isGroupWork(current?.activity)) {
		return undefined
	}
	const end = agendaClock(current, now).now?.plannedEnd
	return end && end.getTime() > now.getTime() ? end : undefined
}
